import styled, { css } from 'styled-components'
import { FlexColumn } from '../../../../Reusable/Container';
import hexToRgba from 'hex-to-rgba';

export const CardContainer = styled(FlexColumn)`
  ${props => props.gradientBorder ? css`
    position: relative;
    border-radius: 16px;
    padding: ${props => props.padding || `24px 24px`};
    box-shadow: 0px 0px 32px 0px rgba(102, 102, 102, 0.16);
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: inherit;
      padding: 3px; /* Border width */
      background: linear-gradient(111deg,
        ${`rgba(135, 64, 246, 1) -29.15%`}, 
        ${`rgba(17, 153, 255, 1) 78.47%`},
        ${`rgba(17, 153, 255, 1) 100.52%`}
      );
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
      z-index: 1;
    }
    
    /* Make sure content is above the gradient border */
    & > * {
      position: relative;
      z-index: 2;
    }
  ` : css`
    border: ${props => `1px solid ${hexToRgba(props.theme.colors.primary2, 0.1)}`};
    border-radius: 16px;
    padding: ${props => props.padding || `24px 24px`};
    box-shadow: ${props => props.showShadow && `0px 0px 32px 0px rgba(102, 102, 102, 0.16)`};
  `}
`;